const speechsdk = require('microsoft-cognitiveservices-speech-sdk');

import { encodeHTML, getHash } from 'app-core/Data';

let localStoredPhrases = {};

let apiKey = '5bef4b5ca88e49a6a3daf5d7c77f4f0a';
let apiRegion = 'eastus';

export default class MsTextToSpeechProvider {
	init(config) {
		this.config = config;
	}

	async textToSpeech(text, opts) {
		const speechConfig = speechsdk.SpeechConfig.fromSubscription(apiKey, apiRegion);
		const synthesizer = new speechsdk.SpeechSynthesizer(speechConfig, null);
	
		if (__DEBUG__) {
			window.synthesizer = synthesizer;
		}
	
		opts = {
			storeLocal: false,
			...(opts || {})
		}
	
		if (!opts?.isSsml) {
			text = encodeHTML(text || '')
				.replace(/[.?!] /g, '.<mstts:silence type="Sentenceboundary" value="0ms" class="highlighted"></mstts:silence>')
				.trim();
		}
	
		const ssml =
			opts?.isSsml ? text :
			`<speak xmlns="http://www.w3.org/2001/10/synthesis" xmlns:mstts="http://www.w3.org/2001/mstts" xmlns:emo="http://www.w3.org/2009/10/emotionml" version="1.0" xml:lang="en-US">
				<voice name="en-US-JennyNeural">
					<mstts:silence type="Leading" value="0"></mstts:silence>
					<prosody rate="1" pitch="+0%">
						<lang xml:lang="en-US">${text}</lang>
					</prosody>
					<mstts:silence type="Tailing" value="0"></mstts:silence>
				</voice>
			</speak>`;
	
		if (__DEBUG__)
			console.debug('textToSpeech', { text });
	
		const storageKey = getHash(ssml);
	
		const dbVal = localStoredPhrases[storageKey];
		if (opts?.storeLocal && dbVal) {
			return Promise.resolve(dbVal);
		}
	
		if (__DEBUG__)
			console.time('Speech synth time');

		synthesizer.synthesizing = function (s, e) {
			if (opts?.synthesizing) {
				opts.synthesizing(e);
			}
		}

		synthesizer.wordBoundary = function (s, e) {
			if (opts?.wordBoundary) {
				opts.wordBoundary(e);
			}
		}
	
		return new Promise((res, rej) => synthesizer.speakSsmlAsync(
			ssml,
			async result => {
				if (__DEBUG__)
					console.debug('Audio synth', { result });
	
				const audioData = result.audioData;
				if (__DEBUG__)
					console.log(`Audio data byte size: ${audioData.byteLength}.`);
	
				if (opts?.storeLocal)
					localStoredPhrases[storageKey] = result.audioData;
	
				if (__DEBUG__)
					console.timeEnd('Speech synth time');
	
				synthesizer.close();
				res(audioData);
			},
			error => {
				console.error(error);
				synthesizer.close();
				rej(error);
			}))
	}
}